import { CAMPAIGNS_DASHBOARD_PAGE_ROUTE } from 'utils/constants/app';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import VSpacing from 'bloko/blocks/vSpacing';

import { useCampaignsDashboardRedesignAllowed } from 'hooks/useCampaignsDashboardRedesignAllowed';

import { InternalRedirect } from 'app/routes/InternalRedirect/InternalRedirect';

import { Dashboard as DashboardContent } from 'components/Dashboard';

import { Header } from 'components/Header/Header';

import { CampaignsTab } from 'store/models/campaignsDashboard';
import { useSelector } from 'store/utils';

const ARCHIVE_PATH_PART = '/archive';

const Dashboard = () => {
    const isCampaignsDashboardRedesign = useCampaignsDashboardRedesignAllowed();
    const pathname = useSelector((state) => state.router.location.pathname);

    if (isCampaignsDashboardRedesign) {
        const redirectTo = pathname.includes(ARCHIVE_PATH_PART)
            ? `${CAMPAIGNS_DASHBOARD_PAGE_ROUTE}${CampaignsTab.Archived}`
            : CAMPAIGNS_DASHBOARD_PAGE_ROUTE;

        return <InternalRedirect to={redirectTo} />;
    }

    return (
        <>
            <Header />
            <ColumnsWrapper>
                <ColumnsRow>
                    <Column xs="4" s="8" m="12" l="16">
                        <DashboardContent />
                        <VSpacing base={12} />
                    </Column>
                </ColumnsRow>
            </ColumnsWrapper>
        </>
    );
};

export default Dashboard;
